/* eslint-disable react/no-danger */

import React, {Component} from 'react';
import PropTypes from 'prop-types';

import * as Showdown from 'showdown';


class MarkDown extends Component {

    static propTypes = {
        className: PropTypes.string,
        text: PropTypes.string.isRequired,
    };

    converter = null;

    constructor() {
        super();
        this.converter = new Showdown.Converter();
    }

    render() {
        const {text, className} = this.props;
        const html = this.converter.makeHtml(text) || '<p>&nbsp</p>';

        return (
            <div
                className={className || 'mde-preview'}
                dangerouslySetInnerHTML={{__html: html}}
            />
        );
    }
}

export default MarkDown;



// WEBPACK FOOTER //
// ./scripts/components/MarkDown.js